import TeamInvitationModal from './TeamInvitationModal';

export default TeamInvitationModal;
